/**
 * Feature Flags Configuration
 * 
 * Toggle features on/off by changing the boolean values.
 * Set to `true` to enable a feature, `false` to disable it.
 */

export const featureFlags = {
  /** Show the About page and navigation link */
  showAboutPage: false,
  
  /** Show the Career page and navigation link */
  showCareerPage: false,
} as const;

export type FeatureFlags = typeof featureFlags;

